import { getClient } from "../actions/clients";

export const fetchGetClient = (dispatch: any) => (key: string, site: string) => dispatch(getClient(site));
